import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ReceiptIcon from "@mui/icons-material/Receipt";
import GroupIcon from "@mui/icons-material/Group";



import hm from "../assets/images/home.png";
import att from "../assets/images/attendance.png";
import ps from "../assets/images/passkey.png";
import acc from "../assets/images/accounting.png";
import res from "../assets/images/test2.png";
import poshan from "../assets/images/diet.png";
import fe from "../assets/images/receipt.png";
import st from "../assets/images/student.png";
import test from "../assets/images/test.png";
import tt from "../assets/images/timetable.png";
import inv from "../assets/images/inventory.png";
import staff from "../assets/images/staff.png";

import SummarizeIcon from "@mui/icons-material/Summarize";
import AssessmentIcon from "@mui/icons-material/Assessment";
import BarChartIcon from "@mui/icons-material/BarChart";
import WaterfallChartIcon from "@mui/icons-material/WaterfallChart";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SettingsIcon from "@mui/icons-material/Settings";
import Tooltip from "@mui/material/Tooltip";
import "../components/Sidebar.css";
import ReferalCompo from "../pages/PaymentIntegration/ReferalCompo";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import BadgeIcon from "@mui/icons-material/Badge";
import SettingsAccessibilityIcon from "@mui/icons-material/SettingsAccessibility";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import InventoryIcon from "@mui/icons-material/Inventory";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import ListAltIcon from "@mui/icons-material/ListAlt";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import CategoryIcon from "@mui/icons-material/Category";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import BalanceIcon from '@mui/icons-material/Balance';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import RiceBowlIcon from '@mui/icons-material/RiceBowl';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import StoreIcon from '@mui/icons-material/Store';
import VpnKeyIcon from '@mui/icons-material/VpnKey';

const Sidebar = ({ user }) => {
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "English"
  );

  
  const [showStudentDropdown, setShowStudentDropdown] = useState(false);
  const [showExamDropdown, setShowExamDropdown] = useState(false);
  const [showICSEExamDropdown, setShowICSEExamDropdown] = useState(false);
  const [showResultDropdown, setShowResultDropdown] = useState(false);

  const [showPoshanDropdown, setShowPoshanDropdown] = useState(false);
  const [showAttendanceDropdown, setShowAttendanceDropdown] = useState(false);
  const [showKirdDropdown, setShowKirdDropdown] = useState(false);
  const [showFeeDropdown, setShowFeeDropdown] = useState(false);

  const [showExam1Dropdown, setShowExam1Dropdown] = useState(false);
  const [showTimetableDropdown, setShowTimetableDropdown] = useState(false);
  const [showInventoryDropdown, setShowInventoryDropdown] = useState(false);
  const [showTeacherDropdown, setShowTeacherDropdown] = useState(false);



  const [selectedSubmenu, setSelectedSubmenu] = useState("");
  const [isCollapsed, setIsCollapsed] = useState(
    localStorage.getItem("sidebarCollapsed") === "true" || false
  );
  const [isLoading, setIsLoading] = useState(true);


useEffect(() => {
  const loadInitialStatus = async () => {
    const udiseNumber = localStorage.getItem("udiseNumber");
    if (!udiseNumber) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);

      // Load locked modules directly from Firebase
      const lockRes = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/Admin/${udiseNumber}/lockedModule.json`
      );
      const firebaseLockedModules = await lockRes.json() || {};
      setLockedModule(firebaseLockedModules);

    } catch (error) {
      console.error("Failed to load lock status:", error);
    } finally {
      setIsLoading(false);
    }
  };

  loadInitialStatus();
}, []);





















  useEffect(() => {
    const storedLanguage = localStorage.getItem("language") || "English";
    setLanguage(storedLanguage);
  }, []);

  const getLabel = (englishLabel, marathiLabel) => {
    return language === "English" ? englishLabel : marathiLabel;
  };

  const handleSubmenuClick = (submenu) => {
    setSelectedSubmenu(submenu);
  };

  const hasAccess = (path) => {
    if (!user || !user.status) {
      return false; // Deny access if user or status is undefined
    }
    if (
      user.status ===
      "DKglzhgYFYTDT141414HGCkkgfs22117785YFUTFybnujghhgtghghYFYVNOmC234567Omgkysfgvghyfjhyfvv56764"
    ) {
      return true;
    }
    return user.selectedPages?.includes(path);
  };

  // Check if the admin has access to any page in the dropdown
  const hasAccessToDropdown = (pages) => {
    if (!user || !user.status) {
      return false;
    }
    if (
      user.status ===
      "DKglzhgYFYTDT141414HGCkkgfs22117785YFUTFybnujghhgtghghYFYVNOmC234567Omgkysfgvghyfjhyfvv56764"
    ) {
      return true;
    }
    return pages.some((page) => user.selectedPages?.includes(page));
  };



  // Initialize with default unlocked state
  const [lockedModule, setLockedModule] = useState({

    Account: 'unlocked',
    Fee: 'unlocked',
    MDM: 'unlocked',
    Result: 'unlocked',
    Payroll: 'unlocked',
  });

  useEffect(() => {
    const udiseNumber = localStorage.getItem("udiseNumber");

    if (udiseNumber) {
      fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/Admin/${udiseNumber}.json`)
        .then((response) => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        })
        .then((data) => {
          if (data && data.lockedModule) {

            setLockedModule(data.lockedModule);
            console.log("Fetched locked module status:", data.lockedModule);

          }
        })
        .catch((error) => {
          console.error("Failed to fetch lock status:", error);
          // Continue with default unlocked state
        });
    }
  }, []);

  // Helper function to check if a module is unlocked
  const isModuleUnlocked = (moduleName) => {
    // If lockedModule is not loaded yet or module status is undefined, assume unlocked
    if (!lockedModule || lockedModule[moduleName] === undefined) {
      return true; // Default to unlocked
    }
    return lockedModule[moduleName] !== 'locked';
  };


  const handleStudentMenuClick = () => {
    const pages = [
      "/student-register",
      "/admission-details",
      "/rollNo",
      "/all-student-report",
      "/leaving-certificate",
      "/bonafide",
      "/nirgam",
      "/outwordReg",
      "/caste-report",
      "/minority-report",
      "/agewisereport",
      "/IdCard",
      "/generalregister",
      "/stdpersonaldata",
      "/certificates",
      "/importexport",
      "/distribution",
      "/shifaras-form",
      "/form-15a",
      "/promote",
    ];
    if (hasAccessToDropdown(pages)) {
      setShowStudentDropdown((prevState) => !prevState);
      setShowExamDropdown(false);
      setShowPoshanDropdown(false);
      setShowAttendanceDropdown(false);
      setShowICSEExamDropdown(false);
      setShowExam1Dropdown(false);
      setShowTimetableDropdown(false);
      setShowInventoryDropdown(false);
      setShowTeacherDropdown(false);
      setShowFeeDropdown(false)
      setShowKirdDropdown(false);
      setShowResultDropdown(false);
    }
  };

  const handleExamMenuClick = () => {
    const pages = [
      "/GunaNeendani",
      "/progresssheet",
      "/subjectwise",
      "/collectout",
      "/gradewise",
      "/dailyregister",
      "/boardresult",
      "/combinedresult9th10th",
      "/Icse",
      "/promote",
    ];
    if (hasAccessToDropdown(pages)) {
      setShowExamDropdown((prevState) => !prevState);
      setShowStudentDropdown(false);
      setShowPoshanDropdown(false);
      setShowAttendanceDropdown(false);
      setShowICSEExamDropdown(false);
      setShowTimetableDropdown(false);
      setShowExam1Dropdown(false);
      setShowInventoryDropdown(false);
      setShowTeacherDropdown(false);
      setShowFeeDropdown(false)
      setShowKirdDropdown(false);
      setShowResultDropdown(false);
    }
  };

  const handleICSEExamMenuClick = () => {
    const pages = [
      "/IcseMarkRegisteration",
      "/IcseResult",
      "/IcseSubjectWise",
      "/IcseGradeWise",
      "/promote",
    ];
    if (hasAccessToDropdown(pages)) {
      setShowICSEExamDropdown((prevState) => !prevState);
      setShowStudentDropdown(false);
      setShowPoshanDropdown(false);
      setShowAttendanceDropdown(false);
      setShowExamDropdown(false);
      setShowTimetableDropdown(false);
      setShowExam1Dropdown(false);
      setShowInventoryDropdown(false);
      setShowTeacherDropdown(false);
      setShowFeeDropdown(false)
      setShowKirdDropdown(false);
      setShowResultDropdown(false);
    }
  };

  // --------------------
  const handleResultClick = () => {
    const pages = [
      "/preprimary",
      "/cbsesubjectcwise",
      "/cbsemarkentery",
      "/cbseresult",
      "/cbsehsresult",
    ];
    if (hasAccessToDropdown(pages)) {
      setShowResultDropdown((prevState) => !prevState);
      setShowICSEExamDropdown(false);
      setShowStudentDropdown(false);
      setShowPoshanDropdown(false);
      setShowAttendanceDropdown(false);
      setShowExamDropdown(false);
      setShowTimetableDropdown(false);
      setShowExam1Dropdown(false);
      setShowInventoryDropdown(false);
      setShowTeacherDropdown(false);
      setShowFeeDropdown(false)
      setShowKirdDropdown(false);
    }
  };
  // ----------------------------



  const handlePoshanMenuClick = () => {
    const pages = [
      "/dainandin",
      "/sadhyachasatha",
      "/aavaksatha",
      "/menu",
      "/magani",
      "/praman",
      "/eggandbananaReport",
      "/chavreport",
      "/BMIReport",
      "/certificate",
    ];
    if (hasAccessToDropdown(pages)) {
      setShowPoshanDropdown((prevState) => !prevState);
      setShowStudentDropdown(false);
      setShowExamDropdown(false);
      setShowAttendanceDropdown(false);
      setShowICSEExamDropdown(false);
      setShowTimetableDropdown(false);
      setShowExam1Dropdown(false);
      setShowInventoryDropdown(false);
      setShowTeacherDropdown(false);
      setShowFeeDropdown(false)
      setShowKirdDropdown(false);
      setShowResultDropdown(false);
    }
  };

  const handleAttendanceClick = () => {
    const pages = ["/PresentySheet", "/PresentyReport"];
    if (hasAccessToDropdown(pages)) {
      setShowAttendanceDropdown((prevState) => !prevState);
      setShowStudentDropdown(false);
      setShowExamDropdown(false);
      setShowPoshanDropdown(false);
      setShowICSEExamDropdown(false);
      setShowTimetableDropdown(false);
      setShowExam1Dropdown(false);
      setShowInventoryDropdown(false);
      setShowTeacherDropdown(false);
      setShowFeeDropdown(false)
      setShowKirdDropdown(false);
      setShowResultDropdown(false);
    }
  };

  const handleTimetableClick = () => {
    const pages = ["/principleform", "/teachertimetable", "/timetableform", "/timetableform1", "/weekdayform",
    ];
    if (hasAccessToDropdown(pages)) {
      setShowTimetableDropdown((prevState) => !prevState);
      setShowStudentDropdown(false);
      setShowExamDropdown(false);
      setShowExam1Dropdown(false);
      setShowPoshanDropdown(false);
      setShowICSEExamDropdown(false);
      setShowAttendanceDropdown(false)
      setShowInventoryDropdown(false);
      setShowTeacherDropdown(false);
      setShowFeeDropdown(false)
      setShowKirdDropdown(false);
      setShowResultDropdown(false);
    }
  };

  const handleExam1Click = () => {
    const pages = ["/teacherandqueform", "/taketest", "/studentresult"];
    if (hasAccessToDropdown(pages)) {
      setShowExam1Dropdown((prevState) => !prevState);
      setShowStudentDropdown(false);
      setShowExamDropdown(false);
      setShowPoshanDropdown(false);
      setShowICSEExamDropdown(false);
      setShowInventoryDropdown(false);
      setShowTeacherDropdown(false);
      setShowFeeDropdown(false)
      setShowKirdDropdown(false);
      setShowResultDropdown(false);
    }
  };

  const handleTeacherClick = () => {
    const pages = ["/addteacher", "/dailyreport", "/viewattendance"];
    if (hasAccessToDropdown(pages)) {
      setShowTeacherDropdown(prevState => !prevState);
      setShowStudentDropdown(false);
      setShowExamDropdown(false);
      setShowExam1Dropdown(false);
      setShowPoshanDropdown(false);
      setShowICSEExamDropdown(false);
      setShowTimetableDropdown(false);
      setShowInventoryDropdown(false);
      setShowFeeDropdown(false)
      setShowKirdDropdown(false);
      setShowResultDropdown(false);
    }
  };


  const handleKirdMenuClick = () => {
    const pages = ["/kird"];
    if (hasAccessToDropdown(pages)) {
      setShowKirdDropdown(prevState => !prevState)
      setShowAttendanceDropdown(false);
      setShowStudentDropdown(false);
      setShowExamDropdown(false);
      setShowPoshanDropdown(false);
      setShowICSEExamDropdown(false);
      setShowTimetableDropdown(false);
      setShowExam1Dropdown(false);
      setShowInventoryDropdown(false);
      setShowTeacherDropdown(false);
      setShowFeeDropdown(false)
      setShowResultDropdown(false);
    }
  };


  const handleFeeMenuClick = () => {
    const pages = ["/atm1", "/pavati"];
    if (hasAccessToDropdown(pages)) {
      setShowFeeDropdown(prevState => !prevState)
      setShowAttendanceDropdown(false);
      setShowStudentDropdown(false);
      setShowExamDropdown(false);
      setShowPoshanDropdown(false);
      setShowICSEExamDropdown(false);
      setShowTimetableDropdown(false);
      setShowExam1Dropdown(false);
      setShowInventoryDropdown(false);
      setShowTeacherDropdown(false);
      setShowKirdDropdown(false);
      setShowResultDropdown(false);
    }
  };

  const handleHomeMenuClick = () => {
    const pages = ["/homw"];
    if (hasAccessToDropdown(pages)) {
      setShowFeeDropdown(false)
      setShowAttendanceDropdown(false);
      setShowStudentDropdown(false);
      setShowExamDropdown(false);
      setShowPoshanDropdown(false);
      setShowICSEExamDropdown(false);
      setShowTimetableDropdown(false);
      setShowExam1Dropdown(false);
      setShowInventoryDropdown(false);
      setShowTeacherDropdown(false);
      setShowKirdDropdown(false);
      setShowResultDropdown(false);
    }
  }

  useEffect(() => {
    // On mount set body class if needed
    if (isCollapsed) {
      document.body.classList.add("sidebar-collapsed");
    } else {
      document.body.classList.remove("sidebar-collapsed");
    }
  }, [isCollapsed]);
  const toggleSidebar = () => {
    const newCollapsed = !isCollapsed;
    setIsCollapsed(newCollapsed);
    if (newCollapsed) {
      document.body.classList.add("sidebar-collapsed");
    } else {
      document.body.classList.remove("sidebar-collapsed");
    }
    localStorage.setItem("sidebarCollapsed", newCollapsed.toString());
  };

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>

    
      <style>{

        `
.icon {
  filter: invert(0%) brightness(0);
}
  `
      }</style>

      {hasAccess("/home") && (
        <Tooltip title={getLabel("Home", "होम")} arrow

          className="main-menus"
          style={{ fontSize: "16px", paddingLeft: "9px" }}
        >
          <Link onClick={handleHomeMenuClick} to="/home">
            <img src={hm} className="icon" style={{ height: '30px', margin: '-2px', marginRight: '9px' }} />

            <span>
              <b>{getLabel("Home", "होम")}</b>
            </span>
          </Link>
        </Tooltip>
      )}



{/* 
{hasAccess("/feedashboard") && (
        <Tooltip title={getLabel("FeeDashboard", "विभाग")} arrow  

          className="main-menus"
          style={{ fontSize: "16px", paddingLeft: "9px" }}
        >
          <Link to="/feedashboard">
            <img src={hm} className="icon" style={{ height: '30px', margin: '-2px', marginRight: '9px' }} />

            <span>
              <b>{getLabel("FeeDashboard", "विभाग")}</b>
            </span>
          </Link>
        </Tooltip>
      )} */}




      {hasAccessToDropdown([
        "/student-register",
        "/admission-details",
        "/rollNo",
        "/all-student-report",
        "/leaving-certificate",
        "/bonafide",
        "/nirgam",
        "/outwordReg",
        "/caste-report",
        "/minority-report",
        "/agewisereport",
        "/IdCard",
        "/generalregister",
        "/stdpersonaldata",
        "/certificates",
        "/importexport",
        "/distribution",
        "/shifaras-form",
        "/form-15a",
        "/promote",
      ]) && (
          <Tooltip title={getLabel("Student", "विद्यार्थी")} arrow
            style={{ fontSize: "16px", paddingLeft: "9px" }}
            className="main-menus"
            onClick={handleStudentMenuClick}
          >
            <p className="main-menus">
              <img className="icon" src={st} style={{ height: '30px', margin: '-2px', marginRight: '9px' }} />

              <span>
                <b>{getLabel("Student", "विद्यार्थी")}</b>
              </span>
            </p>
          </Tooltip>
        )}

      {showStudentDropdown && (
        <div className="submenu">
          {hasAccess("/student-register") && (
            <Tooltip title={getLabel("New students", "नवीन विद्यार्थी")} arrow>
              <Link onClick={() => handleSubmenuClick("student-register")} className={selectedSubmenu === "student-register" ? "active" : ""} to="/student-register" >
                <PersonAddIcon />
                <span>{getLabel("New students", "नवीन विद्यार्थी")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/admission-details") && (
            <Tooltip title={getLabel("Admission Forms", "प्रवेश फॉर्म")} arrow>
              <Link onClick={() => handleSubmenuClick("admission-details")} className={selectedSubmenu === "admission-details" ? "active" : ""} to="/admission-details">
                <DynamicFormIcon />
                <span>{getLabel("Admission Forms", "प्रवेश फॉर्म")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/rollNo") && (
            <Tooltip title={getLabel("Roll Number", "हजेरी क्रमांक")} arrow>
              <Link onClick={() => handleSubmenuClick("rollNo")} className={selectedSubmenu === "rollNo" ? "active" : ""} to="/rollNo">
                <FormatListNumberedIcon />
                <span>{getLabel("Roll Number", "हजेरी क्रमांक")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/all-student-report") && (
            <Tooltip title={getLabel("Student Report", "विद्यार्थी अहवाल")} arrow>
              <Link onClick={() => handleSubmenuClick("all-student-report")} className={selectedSubmenu === "all-student-report" ? "active" : ""} to="/all-student-report">
                <SummarizeIcon />
                <span>{getLabel("Student Report", "विद्यार्थी अहवाल")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/leaving-certificate") && (
            <Tooltip title={getLabel("Leaving Certificate", "शाळा सोडल्याचा दाखला")} arrow>
              <Link onClick={() => handleSubmenuClick("leaving-certificate")} className={selectedSubmenu === "leaving-certificate" ? "active" : ""} to="/leaving-certificate">
                <ReceiptIcon />
                <span>
                  {getLabel("Leaving Certificate", "शाळा सोडल्याचा दाखला")}
                </span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/bonafide") && (
            <Tooltip title={getLabel("Bonafide", "बोनाफाईड")} arrow>
              <Link onClick={() => handleSubmenuClick("bonafide")} className={selectedSubmenu === "bonafide" ? "active" : ""} to="/bonafide">
                <ReceiptIcon />
                <span>{getLabel("Bonafide", "बोनाफाईड")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/nirgam") && (
            <Tooltip title={getLabel("Nirgam Report", "निर्गम उतारा")} arrow>
              <Link onClick={() => handleSubmenuClick("nirgam")} className={selectedSubmenu === "nirgam" ? "active" : ""} to="/nirgam">
                <ReceiptIcon />
                <span>{getLabel("Nirgam Report", "निर्गम उतारा")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/outwordReg") && (
            <Tooltip title={getLabel("Outward Report", "जावक उतारा")} arrow>
              <Link onClick={() => handleSubmenuClick("outwordReg")} className={selectedSubmenu === "outwordReg" ? "active" : ""} to="/outwordReg">
                <ReceiptIcon />
                <span>{getLabel("Outward Report", "जावक उतारा")}</span>
              </Link>
            </Tooltip>
          )}



          {hasAccess("/caste-report") && (
            <Tooltip title={getLabel("Caste Report", "जात अहवाल")} arrow>
              <Link onClick={() => handleSubmenuClick("caste-report")} className={selectedSubmenu === "caste-report" ? "active" : ""} to="/caste-report">
                <AssessmentIcon />
                <span>{getLabel("Caste Report", "जात अहवाल")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/minority-report") && (
            <Tooltip title={getLabel("Minority Report", "अल्पसंख्याक अहवाल")} arrow>
              <Link onClick={() => handleSubmenuClick("minority-report")} className={selectedSubmenu === "minority-report" ? "active" : ""} to="/minority-report">
                <BarChartIcon />
                <span>{getLabel("Minority Report", "अल्पसंख्याक अहवाल")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/agewisereport") && (
            <Tooltip title={getLabel("Age Report", "वय अहवाल")} arrow>
              <Link onClick={() => handleSubmenuClick("agewisereport")} className={selectedSubmenu === "agewisereport" ? "active" : ""} to="/agewisereport">
                <WaterfallChartIcon />
                <span>{getLabel("Age Report", "वय अहवाल")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/IdCard") && (
            <Tooltip title={getLabel("IdCard", "ओळखपत्र")} arrow>
              <Link onClick={() => handleSubmenuClick("IdCard")} className={selectedSubmenu === "IdCard" ? "active" : ""} to="/IdCard">
                <BadgeIcon />
                <span>{getLabel("IdCard", "ओळखपत्र")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/generalregister") && (
            <Tooltip title={getLabel("General Register 1", "जनरल रजि.1")} arrow>
              <Link onClick={() => handleSubmenuClick("generalregister")} className={selectedSubmenu === "generalregister" ? "active" : ""} to="/generalregister">
                <ReceiptIcon />
                <span>{getLabel("General Register 1", "जनरल रजि.1")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/stdpersonaldata") && (
            <Tooltip title={getLabel("Height/Weight", "वजन/ऊंची")} arrow>
              <Link onClick={() => handleSubmenuClick("stdpersonaldata")} className={selectedSubmenu === "stdpersonaldata" ? "active" : ""} to="/stdpersonaldata">
                <SettingsAccessibilityIcon />
                <span>{getLabel("Height/Weight", "वजन/ऊंची")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/certificates") && (
            <Tooltip title={getLabel("certificate", "प्रमाणपत्र")} arrow>
              <Link onClick={() => handleSubmenuClick("certificates")} className={selectedSubmenu === "certificates" ? "active" : ""} to="/certificates">
                <CardMembershipIcon />
                <span>{getLabel("certificate", "प्रमाणपत्र")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/importexport") && (
            <Tooltip title={getLabel("Import/Export", "आयात/निर्यात")} arrow>
              <Link onClick={() => handleSubmenuClick("importexport")} className={selectedSubmenu === "importexport" ? "active" : ""} to="/importexport">
                <ImportExportIcon />
                <span>
                  {getLabel("Import/Export", "आयात/निर्यात")}
                </span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/distribution") && (
            <Tooltip title={getLabel("School Supplies", "शालेय साहित्य")} arrow>
              <Link onClick={() => handleSubmenuClick("distribution")} className={selectedSubmenu === "distribution" ? "active" : ""} to="/distribution">
                <CategoryIcon />
                <span>{getLabel("School Supplies", "शालेय साहित्य")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/shifaras-form") && (
            <Tooltip title={getLabel("Shifaras Form", "शिफारस फॉर्म")} arrow>
              <Link onClick={() => handleSubmenuClick("shifaras-form")} className={selectedSubmenu === "shifaras-form" ? "active" : ""} to="/shifaras-form">
                <DynamicFormIcon />
                <span>{getLabel("Shifaras Form", "शिफारस फॉर्म")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/form-15a") && (
            <Tooltip title={getLabel("Form 15A", "फॉर्म १५ए")} arrow>
              <Link onClick={() => handleSubmenuClick("form-15a")} className={selectedSubmenu === "form-15a" ? "active" : ""} to="/form-15a">
                <DynamicFormIcon />
                <span>{getLabel("Form 15A", "फॉर्म १५ए")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/promote") && (
            <Tooltip title={getLabel("Promote Students", "विद्यार्थी बढती")} arrow>
              <Link onClick={() => handleSubmenuClick("promote")} className={selectedSubmenu === "promote" ? "active" : ""} to="/promote">
                <MoveUpIcon />
                <span>{getLabel("Promote Students", "विद्यार्थी बढती")}</span>
              </Link>
            </Tooltip>
          )}
        </div>
      )}


      {hasAccessToDropdown(["/PresentySheet", "/PresentyReport"]) && (
        <Tooltip title={getLabel("Attendance", "हजेरी")} arrow
          style={{ fontSize: "16px", paddingLeft: "9px" }}
          className="main-menus"
          onClick={handleAttendanceClick}
        >
          <p>
            <img className="icon" src={att} style={{ height: '29px', margin: '-2px', marginRight: '9px' }} />
            <span>
              <b>{getLabel("Attendance", "हजेरी")}</b>
            </span>
          </p>
        </Tooltip>
      )}

      {showAttendanceDropdown && (
        <div className="submenu">
          {hasAccess("/PresentySheet") && (
            <Tooltip title={getLabel("Take Attendance", "हजेरी घ्या")} arrow>
              <Link onClick={() => handleSubmenuClick("PresentySheet")} className={selectedSubmenu === "PresentySheet" ? "active" : ""} to="/PresentySheet">
                <BorderColorIcon />
                <span>{getLabel("Take Attendance", "हजेरी घ्या")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/PresentyReport") && (
            <Tooltip title={getLabel("Catalogue ", "कॅटलॉग")} arrow>
              <Link onClick={() => handleSubmenuClick("PresentyReport")} className={selectedSubmenu === "PresentyReport" ? "active" : ""} to="/PresentyReport">
                <ReceiptIcon />
                <span>{getLabel("Catalogue ", "कॅटलॉग")}</span>
              </Link>
            </Tooltip>
          )}
        </div>
      )}


      {hasAccessToDropdown(["/kird"]) && (
        <Tooltip title={getLabel("Account", "किर्द ")} arrow
          style={{ fontSize: "16px", paddingLeft: "9px" }}
          className="main-menus"
        >
          {isLoading ? (
            <p className="main-menus">
              <img className="icon" src={acc} style={{ height: '30px', margin: '-2px', marginRight: '9px' }} />
              <span><b>{getLabel("Account", "किर्द ")}</b></span>
            </p>
          ) : lockedModule && lockedModule.Account === 'locked' ? (
            <p
              className="main-menus disabled-link"
              style={{ cursor: 'not-allowed' }}
            >
              <img className="icon" src={acc} style={{ height: '30px', margin: '-2px', marginRight: '9px' }} />
              <span><b>{getLabel("Account", "किर्द ")}</b></span>
              <span style={{
                position: 'absolute',
                right: '10px',
                fontSize: '14px'
              }}>🔐</span>
            </p>
          ) : (
            <p onClick={handleKirdMenuClick}>
              <img className="icon" src={acc} style={{ height: '30px', margin: '-2px', marginRight: '9px' }} />
              <span><b>{getLabel("Account", "किर्द ")}</b></span>
            </p>
          )}
        </Tooltip>
      )}




      {showKirdDropdown && lockedModule && lockedModule.Account !== 'locked' && (
        <div className="submenu">
          {hasAccess("/kird") && (
            <Tooltip title={getLabel("Account", "किर्द ")} arrow>
              <Link onClick={() => handleSubmenuClick("kird")} className={selectedSubmenu === "kird" ? "active" : ""} to="/kird">
                <MenuBookIcon />
                <span>{getLabel("Account", "किर्द ")}</span>
              </Link>
            </Tooltip>
          )}

        </div>
      )}

      {hasAccessToDropdown(["/atm1", "/pavati"]) && (
        <Tooltip title={getLabel("Fee", "फी")} arrow style={{ fontSize: "16px", paddingLeft: "9px" }} className="main-menus">
          {lockedModule?.Fee === 'locked' ? (
            <p className="main-menus disabled-link" style={{ cursor: 'not-allowed' }}>
              <img className="icon" src={fe} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />
              <span><b>{getLabel("Fee", "फी")}</b></span>
              <span style={{ position: 'absolute', right: '10px', fontSize: '14px' }}>🔐</span>
            </p>
          ) : (
            <p onClick={handleFeeMenuClick}>
              <img className="icon" src={fe} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />
              <span><b>{getLabel("Fee", "फी")}</b></span>
            </p>
          )}
        </Tooltip>
      )}


      {showFeeDropdown && lockedModule && lockedModule.Fee !== 'locked' && (
        <div className="submenu">
          {hasAccess("/atm1") && (
            <Tooltip title={getLabel("Add Fee", "फी भरा")} arrow>
              <Link onClick={() => handleSubmenuClick("atm1")} className={selectedSubmenu === "atm1" ? "active" : ""} to="/atm1">
                <ReceiptLongIcon />
                <span>{getLabel("Add Fee", "फी भरा")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/pavati") && (
            <Tooltip title={getLabel("Fee Reports", "फी रिपोर्ट")} arrow>
              <Link onClick={() => handleSubmenuClick("pavati")} className={selectedSubmenu === "pavati" ? "active" : ""} to="/pavati">
                <ReceiptLongIcon />
                <span>{getLabel("Fee Reports", "फी रिपोर्ट")}</span>
              </Link>
            </Tooltip>
          )}
        </div>
      )}

      {hasAccessToDropdown([
        "/dainandin", "/sadhyachasatha", "/aavaksatha", "/menu", "/magani",
        "/praman", "/eggandbananaReport", "/chavreport", "/BMIReport", "/certificate"
      ]) && (
          <Tooltip title={getLabel("MDM", "पोषण आहार")} arrow style={{ fontSize: "16px", paddingLeft: "9px" }} className="main-menus">
            {lockedModule?.MDM === 'locked' ? (
              <p className="main-menus disabled-link" style={{ cursor: 'not-allowed' }}>
                <img className="icon" src={poshan} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />
                <span><b>{getLabel("MDM", "पोषण आहार")}</b></span>
                <span style={{ position: 'absolute', right: '10px', fontSize: '14px' }}>🔐</span>
              </p>
            ) : (
              <p onClick={handlePoshanMenuClick}>
                <img className="icon" src={poshan} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />
                <span><b>{getLabel("MDM", "पोषण आहार")}</b></span>
              </p>
            )}
          </Tooltip>
        )}


      {showPoshanDropdown && lockedModule && lockedModule.MDM !== 'locked' && (
        <div className="submenu">
          {hasAccess("/praman") && (
            <Tooltip title={getLabel("Quantity", "आहार प्रमाण")} arrow>
              <Link onClick={() => handleSubmenuClick("praman")} className={selectedSubmenu === "praman" ? "active" : ""} to="/praman">
                <ProductionQuantityLimitsIcon />
                <span>{getLabel("Quantity", "आहार प्रमाण")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/menu") && (
            <Tooltip title={getLabel("Menu", "आहार मेनू")} arrow>
              <Link onClick={() => handleSubmenuClick("menu")} className={selectedSubmenu === "menu" ? "active" : ""} to="/menu">
                <ListAltIcon />
                <span>{getLabel("Menu", "आहार मेनू")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/aavaksatha") && (
            <Tooltip title={getLabel("incoming entry", "आवक नोंद")} arrow>
              <Link onClick={() => handleSubmenuClick("aavaksatha")} className={selectedSubmenu === "aavaksatha" ? "active" : ""} to="/aavaksatha">
                <MoveToInboxIcon />
                <span>{getLabel("incoming entry", "आवक नोंद")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/dainandin") && (
            <Tooltip title={getLabel("Daily register ", "दैनंदिन नोंदवही")} arrow>
              <Link onClick={() => handleSubmenuClick("dainandin")} className={selectedSubmenu === "dainandin" ? "active" : ""} to="/dainandin">
                <CalendarMonthIcon />
                <span>{getLabel("Daily register ", "दैनंदिन नोंदवही ")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/sadhyachasatha") && (
            <Tooltip title={getLabel("Current stock", "सध्याचा साठा")} arrow>
              <Link onClick={() => handleSubmenuClick("sadhyachasatha")} className={selectedSubmenu === "sadhyachasatha" ? "active" : ""} to="/sadhyachasatha">
                <InventoryIcon />
                <span>{getLabel("Current stock", "सध्याचा साठा ")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/magani") && (
            <Tooltip title={getLabel("Demand", "मागणी")} arrow>
              <Link onClick={() => handleSubmenuClick("magani")} className={selectedSubmenu === "magani" ? "active" : ""} to="/magani">
                <ReceiptIcon />
                <span>{getLabel("Demand", "मागणी")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/eggandbananaReport") && (
            <Tooltip title={getLabel("Egg/Banana Report", "अंडी/केळी अहवाल")} arrow>
              <Link onClick={() => handleSubmenuClick("eggandbananaReport")} className={selectedSubmenu === "eggandbananaReport" ? "active" : ""} to="/eggandbananaReport">
                <ReceiptIcon />
                <span>{getLabel("Egg/Banana Report", "अंडी/केळी अहवाल")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/chavreport") && (
            <Tooltip title={getLabel("Taste Report", "चव अहवाल")} arrow>
              <Link onClick={() => handleSubmenuClick("chavreport")} className={selectedSubmenu === "chavreport" ? "active" : ""} to="/chavreport">
                <ReceiptIcon />
                <span>{getLabel("Taste Report", "चव अहवाल")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/BMIReport") && (
            <Tooltip title={getLabel("BMI Report", "BMI Report")} arrow>
              <Link onClick={() => handleSubmenuClick("BMIReport")} className={selectedSubmenu === "BMIReport" ? "active" : ""} to="/BMIReport">
                <ReceiptIcon />
                <span>{getLabel("BMI Report", "BMI Report")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/certificate") && (
            <Tooltip title={getLabel("Certificate", "प्रमाणपत्र")} arrow>
              <Link onClick={() => handleSubmenuClick("certificate")} className={selectedSubmenu === "certificate" ? "active" : ""} to="/certificate">
                <CardMembershipIcon />
                <span>{getLabel("Certificate", "प्रमाणपत्र")}</span>
              </Link>
            </Tooltip>
          )}
        </div>
      )}

      {hasAccessToDropdown([
        "/GunaNeendani", "/resulthsc", "/resultssc", "/prgReportwd", "/progresssheet",
        "/collectout", "/subjectwise", "/gradewise", "/dailyregister", "/boardresult",
        "/combinedresult9th10th", "/Icse", "/promote"
      ]) && (
          <Tooltip title={getLabel("Result", "निकालपत्र")} arrow style={{ fontSize: "16px", paddingLeft: "9px" }} className="main-menus">
            {lockedModule?.Result === 'locked' ? (
              <p className="main-menus disabled-link" style={{ cursor: 'not-allowed' }}>
                <img className="icon2" src={res} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />
                <span><b>{getLabel("Result", "निकालपत्र")}</b></span>
                <span style={{ position: 'absolute', right: '10px', fontSize: '14px' }}>🔐</span>
              </p>
            ) : (
              <p onClick={handleExamMenuClick}>
                <img className="icon2" src={res} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />
                <span><b>{getLabel("Result", "निकालपत्र")}</b></span>
              </p>
            )}
          </Tooltip>
        )}


      {showExamDropdown && lockedModule && lockedModule.Result !== 'locked' && (
        <div className="submenu">
          {hasAccess("/GunaNeendani") && (
            <Tooltip title={getLabel("Mark Registration", "गुण नोंदणी")} arrow>
              <Link onClick={() => handleSubmenuClick("GunaNeendani")} className={selectedSubmenu === "GunaNeendani" ? "active" : ""} to="/GunaNeendani">
                <BorderColorIcon />
                <span>{getLabel("Mark Registration", "गुण नोंदणी")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/progresssheet") && (
            <Tooltip title={getLabel("Progress sheet", "प्रगती पत्रक")} arrow>
              <Link onClick={() => handleSubmenuClick("progresssheet")} className={selectedSubmenu === "progresssheet" ? "active" : ""} to="/progresssheet">
                <AssessmentIcon />
                <span>{getLabel("Progress sheet", "प्रगती पत्रक")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/collectout") && (
            <Tooltip title={getLabel("combined result", "एकत्रित निकाल")} arrow>
              <Link onClick={() => handleSubmenuClick("collectout")} className={selectedSubmenu === "collectout" ? "active" : ""} to="/collectout">
                <AssessmentIcon />
                <span>{getLabel("combined result", "एकत्रित निकाल")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/subjectwise") && (
            <Tooltip title={getLabel("Subject wise results", "विषयनिहाय निकाल")} arrow>
              <Link onClick={() => handleSubmenuClick("subjectwise")} className={selectedSubmenu === "subjectwise" ? "active" : ""} to="/subjectwise">
                <AssessmentIcon />
                <span>
                  {getLabel("Subject wise results", "विषयनिहाय निकाल")}
                </span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/gradewise") && (
            <Tooltip title={getLabel("Grade Wise Results", "श्रेणी निहाय निकाल")} arrow>
              <Link onClick={() => handleSubmenuClick("gradewise")} className={selectedSubmenu === "gradewise" ? "active" : ""} to="/gradewise">
                <AssessmentIcon />
                <span>
                  {getLabel("Grade Wise Results", "श्रेणी निहाय निकाल")}
                </span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/dailyregister") && (
            <Tooltip title={getLabel("Daily register", "दैनंदिन नोंदवही")} arrow>
              <Link onClick={() => handleSubmenuClick("dailyregister")} className={selectedSubmenu === "dailyregister" ? "active" : ""} to="/dailyregister">
                <CalendarMonthIcon />
                <span>{getLabel("Daily register", "दैनंदिन नोंदवही")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/boardresult") && (
            <Tooltip title={getLabel("5th & 8th Result", "५वी आणि ८वी निकाल")} arrow>
              <Link onClick={() => handleSubmenuClick("boardresult")} className={selectedSubmenu === "boardresult" ? "active" : ""} to="/boardresult">
                <AssessmentIcon />
                <span>
                  {getLabel("5th & 8th Result", "५वी आणि ८वी निकाल")}
                </span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/resultssc") && (
            <Tooltip title={getLabel("SSC Result", "SSC निकाल")} arrow>
              <Link onClick={() => handleSubmenuClick("resultssc")} className={selectedSubmenu === "resultssc" ? "active" : ""} to="/resultssc">
                <AssessmentIcon />
                <span>{getLabel("SSC Result", "SSC निकाल")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/resulthsc") && (
            <Tooltip title={getLabel("HSC Result", "HSC निकाल")} arrow>
              <Link onClick={() => handleSubmenuClick("resulthsc")} className={selectedSubmenu === "resulthsc" ? "active" : ""} to="/resulthsc">
                <AssessmentIcon />
                <span>{getLabel("HSC Result", "HSC निकाल")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/prgReportwd") && (
            <Tooltip title={getLabel("View Report", "अहवाल पहा")} arrow>
              <Link onClick={() => handleSubmenuClick("prgReportwd")} className={selectedSubmenu === "prgReportwd" ? "active" : ""} to="/prgReportwd">
                <AssessmentIcon />
                <span>{getLabel("View Report", "अहवाल पहा")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/promote") && (
            <Tooltip title={getLabel("Promote Students", "विद्यार्थी बढती")} arrow>
              <Link onClick={() => handleSubmenuClick("promote")} className={selectedSubmenu === "promote" ? "active" : ""} to="/promote">
                <MoveUpIcon />
                <span>{getLabel("Promote Students", "विद्यार्थी बढती")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/combinedresult9th10th") && (
            <Tooltip title={getLabel("9th & 10th Result", "९वी आणि १०वी निकाल")} arrow>
              <Link onClick={() => handleSubmenuClick("combinedresult9th10th")} className={selectedSubmenu === "combinedresult9th10th" ? "active" : ""} to="/combinedresult9th10th">
                <AssessmentIcon />
                <span>{getLabel("9th & 10th Result", "९वी आणि १०वी निकाल")}</span>
              </Link>
            </Tooltip>
          )}
        </div>
      )}

      {hasAccessToDropdown([
        "/IcseMarkRegisteration",
        "/IcseResult",
        "/IcseSubjectWise",
        "/IcseGradeWise",
        "/prgReportwtd",
        "/promote"
      ]) && (
          <Tooltip
            title={getLabel("ICSE Result", "ICSE निकाल")}
            arrow
            style={{ fontSize: "16px", paddingLeft: "9px" }}
            className="main-menus"
          >
            {lockedModule?.Result === 'locked' ? (
              <p
                className="main-menus disabled-link"
                style={{ cursor: 'not-allowed' }}
              >
                <img className="icon2" src={res} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />
                <span><b>{getLabel("ICSE Result", "ICSE निकाल")}</b></span>
                <span style={{ position: 'absolute', right: '10px', fontSize: '14px' }}>🔐</span>
              </p>
            ) : (
              <p onClick={handleICSEExamMenuClick}>
                <img className="icon2" src={res} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />
                <span><b>{getLabel("ICSE Result", "ICSE निकाल")}</b></span>
              </p>
            )}
          </Tooltip>
        )}

      {showICSEExamDropdown && lockedModule && lockedModule.Result !== 'locked' && (
        <div className="submenu">
          {hasAccess("/IcseMarkRegisteration") && (
            <Tooltip title={getLabel("Mark Registeration", "ICSE निकाल")} arrow>
              <Link onClick={() => handleSubmenuClick("IcseMarkRegisteration")} className={selectedSubmenu === "IcseMarkRegisteration" ? "active" : ""} to="/IcseMarkRegisteration">
                <BorderColorIcon />
                <span>{getLabel("Mark Registeration", "ICSE निकाल")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/IcseResult") && (
            <Tooltip title={getLabel("Icse Result", "प्रगती पत्रक")} arrow>
              <Link onClick={() => handleSubmenuClick("IcseResult")} className={selectedSubmenu === "IcseResult" ? "active" : ""} to="/IcseResult">
                <AssessmentIcon />
                <span>{getLabel("Icse Result", "प्रगती पत्रक")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/IcseSubjectWise") && (
            <Tooltip title={getLabel("Subject wise results", "विषयनिहाय निकाल")} arrow>
              <Link onClick={() => handleSubmenuClick("IcseSubjectWise")} className={selectedSubmenu === "IcseSubjectWise" ? "active" : ""} to="/IcseSubjectWise">
                <AssessmentIcon />
                <span>
                  {getLabel("Subject wise results", "विषयनिहाय निकाल")}
                </span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/IcseGradeWise") && (
            <Tooltip title={getLabel("Grade Wise Results", "श्रेणी निहाय निकाल")} arrow>
              <Link onClick={() => handleSubmenuClick("IcseGradeWise")} className={selectedSubmenu === "IcseGradeWise" ? "active" : ""} to="/IcseGradeWise">
                <AssessmentIcon />
                <span>
                  {getLabel("Grade Wise Results", "श्रेणी निहाय निकाल")}
                </span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/Icse") && (
            <Tooltip title={getLabel("Prelims Result", "प्रिलिम्स प्रगती पत्रक")} arrow>
              <Link onClick={() => handleSubmenuClick("Icse")} className={selectedSubmenu === "Icse" ? "active" : ""} to="/Icse">
                <AssessmentIcon />
                <span>{getLabel("Prelims Result", "प्रगती पत्रक")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/prgReportwtd") && (
            <Tooltip title={getLabel("View Report", "अहवाल पहा")} arrow>
              <Link onClick={() => handleSubmenuClick("prgReportwtd")} className={selectedSubmenu === "prgReportwtd" ? "active" : ""} to="/prgReportwtd">
                <AssessmentIcon />
                <span>{getLabel("View Report", "अहवाल पहा")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/promote") && (
            <Tooltip title={getLabel("Promote Students", "विद्यार्थी बढती")} arrow>
              <Link onClick={() => handleSubmenuClick("promote")} className={selectedSubmenu === "promote" ? "active" : ""} to="/promote">
                <MoveUpIcon />
                <span>{getLabel("Promote Students", "विद्यार्थी बढती")}</span>
              </Link>
            </Tooltip>
          )}
        </div>
      )}


      {hasAccessToDropdown(["/cbsemarkentery"]) && (
        <Tooltip
          title={getLabel("CBSE Result", "CBSE निकाल")}
          arrow
          style={{ fontSize: "16px", paddingLeft: "9px" }}
          className="main-menus"
        >
          {lockedModule?.Result === 'locked' ? (
            <p
              className="main-menus disabled-link"
              style={{ cursor: 'not-allowed' }}
            >
              <img className="icon2" src={res} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />
              <span><b>{getLabel("CBSE Result", "CBSE निकाल")}</b></span>
              <span style={{ position: 'absolute', right: '10px', fontSize: '14px' }}>🔐</span>
            </p>
          ) : (
            <p onClick={handleResultClick}>
              <img className="icon2" src={res} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />
              <span><b>{getLabel("CBSE Result", "CBSE निकाल")}</b></span>
            </p>
          )}
        </Tooltip>
      )}

      {showResultDropdown && lockedModule && lockedModule.Result !== 'locked' && (
        <div className="submenu">
          {hasAccess("/cbsemarkentery") && (
            <Tooltip title={getLabel("Mark Registeration", "गुण नोंदणी")} arrow>
              <Link onClick={() => handleSubmenuClick("cbsemarkentery")} className={selectedSubmenu === "cbsemarkentery" ? "active" : ""} to="/cbsemarkentery">
                <BorderColorIcon />
                <span>{getLabel("Mark Registeration", "गुण नोंदणी")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/cbsehsresult") && (
            <Tooltip title={getLabel("High-school Result", "High-school Result")} arrow>
              <Link onClick={() => handleSubmenuClick("cbsehsresult")} className={selectedSubmenu === "cbsehsresult" ? "active" : ""} to="/cbsehsresult">
                <AssessmentIcon />
                <span>{getLabel("High-school Result", "High-school Result")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/cbseresult") && (

            <Tooltip title={getLabel("Primary Result", "Primary Result")} arrow>
              <Link onClick={() => handleSubmenuClick("cbseresult")} className={selectedSubmenu === "cbseresult" ? "active" : ""} to="/cbseresult">
                <AssessmentIcon />
                <span>{getLabel("Primary Result", "Primary Result")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/preprimary") && (

            <Tooltip title={getLabel("Pre-Primary Result", "Pre-Primary Result")} arrow>
              <Link onClick={() => handleSubmenuClick("preprimary")} className={selectedSubmenu === "preprimary" ? "active" : ""} to="/preprimary">
                <AssessmentIcon />
                <span>{getLabel("Pre-Primary Result", "Pre-Primary Result")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/cbsesubjectcwise") && (
            <Tooltip title={getLabel("Subject Wise Result", "Subject Wise Result")} arrow>
              <Link onClick={() => handleSubmenuClick("cbsesubjectcwise")} className={selectedSubmenu === "cbsesubjectcwise" ? "active" : ""} to="/cbsesubjectcwise">
                <AssessmentIcon />
                <span>{getLabel("Subject Wise Result", "Subject Wise Result")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/promote") && (
            <Tooltip title={getLabel("Promote Students", "विद्यार्थी बढती")} arrow>
              <Link onClick={() => handleSubmenuClick("promote")} className={selectedSubmenu === "promote" ? "active" : ""} to="/promote">
                <MoveUpIcon />
                <span>{getLabel("Promote Students", "विद्यार्थी बढती")}</span>
              </Link>
            </Tooltip>
          )}
        </div>
      )}


   


      {hasAccessToDropdown(["/addteacher", "/dailyreport", "/viewattendance"]) && (
        <Tooltip
          title={getLabel("Payroll", "कर्मचारी")}
          arrow
          style={{ fontSize: '16px', paddingLeft: '9px' }}
          className="main-menus"
        >
          {lockedModule?.Payroll === 'locked' ? (
            <p
              className="main-menus disabled-link"
              style={{ cursor: 'not-allowed' }}
            >
              <img className="icon" src={staff} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />
              <span><b>{getLabel("Payroll", "कर्मचारी")}</b></span>
              <span style={{ position: 'absolute', right: '10px', fontSize: '14px' }}>🔐</span>
            </p>
          ) : (
            <p onClick={handleTeacherClick} className="main-menus">
              <img className="icon" src={staff} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />
              <span><b>{getLabel("Payroll", "कर्मचारी")}</b></span>
            </p>
          )}
        </Tooltip>
      )}




      {showTeacherDropdown && lockedModule && lockedModule.Payroll !== 'locked' && (
        <div className="submenu">
          {hasAccess("/addteacher") && (
            <Tooltip title={getLabel("Add Staff", "कर्मचारी भरा")} arrow>
              <Link onClick={() => handleSubmenuClick("addteacher")} className={selectedSubmenu === "addteacher" ? "active" : ""} to="/addteacher">
                <PersonAddAlt1Icon />
                <span>{getLabel("Add Staff", "कर्मचारी भरा")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/dailyreport", "/viewattendance") && (
            <Tooltip title={getLabel("Staff Payroll", "कर्मचारी वेतन")} arrow>
              <Link onClick={() => handleSubmenuClick("dailyreport")} className={selectedSubmenu === "dailyreport" ? "active" : ""} to="/dailyreport">
                <DashboardIcon />
                <span>{getLabel("Staff Payroll", "कर्मचारी वेतन")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/TIdCard") && (
            <Tooltip title={getLabel("Id Card ", "ओळखपत्र")} arrow>
              <Link onClick={() => handleSubmenuClick("TIdCard")} className={selectedSubmenu === "TIdCard" ? "active" : ""} to="/TIdCard">
                <BadgeIcon />
                <span>{getLabel("Id Card ", "ओळखपत्र")}</span>
              </Link>
            </Tooltip>
          )}
        </div>
      )}

   {hasAccessToDropdown(["/teacherandqueform", "/taketest", "/studentresult"]) && (
        <Tooltip title={getLabel("Exam", "परीक्षा")} arrow style={{ fontSize: '16px', paddingLeft: '9px' }} className="main-menus" onClick={handleExam1Click}>
          <p className="main-menus">
            <img className="icon" src={test} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />

            <i style={{ fontSize: '20px', marginLeft: '1px', marginRight: '1px' }}></i>
            <span><b>{getLabel("Exam", "परीक्षा")}</b></span>
          </p>
        </Tooltip>
      )}

      {showExam1Dropdown && (
        <div className="submenu">
          {hasAccess("/teacherandqueform") && (
            <Tooltip title={getLabel("Create Test", "test तयार करा")} arrow>
              <Link onClick={() => handleSubmenuClick("teacherandqueform")} className={selectedSubmenu === "teacherandqueform" ? "active" : ""} to="/teacherandqueform">
                <DashboardIcon />
                <span>{getLabel("Create Test", "test तयार करा")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/taketest") && (
            <Tooltip title={getLabel("Take Test", "test घ्या")} arrow>
              <Link onClick={() => handleSubmenuClick("taketest")} className={selectedSubmenu === "taketest" ? "active" : ""} to="/taketest">
                <LibraryBooksIcon />
                <span>{getLabel("Take Test", "test घ्या")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/studentresult") && (
            <Tooltip title={getLabel("Result", "निकाल")} arrow >
              <Link onClick={() => handleSubmenuClick("studentresult")} className={selectedSubmenu === "studentresult" ? "active" : ""} to="/studentresult">
                <AccountBalanceWalletIcon />
                <span>{getLabel("Result", "निकाल")}</span>
              </Link>
            </Tooltip>
          )}
        </div>
      )}

      {hasAccessToDropdown([
        "/addSubject",
        "/principleform",
        "/teachertimetable",
        "/timetableform",
        "/timetableform1",
        "/weekdayform",
      ]) && (
          <Tooltip title={getLabel("Time Table", "वेळापत्रक")} arrow
            style={{ fontSize: "16px", paddingLeft: "9px" }}
            className="main-menus"
            onClick={handleTimetableClick}
          >
            <p className="main-menus">
              <img className="icon" src={tt} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />

              <i
                style={{
                  fontSize: "20px",
                  marginLeft: "1px",
                  marginRight: "1px",
                }}
              ></i>
              <span>
                <b>{getLabel("Time Table", "वेळापत्रक")}</b>
              </span>
            </p>
          </Tooltip>
        )}

      {showTimetableDropdown && (
        <div className="submenu">
          {hasAccess("/addSubject") && (
            <Tooltip title={getLabel("Add Subject", "विषय जोडा")} arrow>
              <Link onClick={() => handleSubmenuClick("addSubject")} className={selectedSubmenu === "addSubject" ? "active" : ""} to="/addSubject">
                <MenuBookIcon />
                <span>
                  {getLabel("Add Subject", "विषय जोडा")}
                </span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/addteacher") && (
            <Tooltip title={getLabel("Add Teacher", "शिक्षक जोडा")} arrow>
              <Link onClick={() => handleSubmenuClick("addteacher")} className={selectedSubmenu === "addteacher" ? "active" : ""} to="/addteacher">
                <PersonAddIcon />
                <span>
                  {getLabel("Add Teacher", "शिक्षक जोडा")}
                </span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/timetableform") && (
            <Tooltip title={getLabel("Assign Class-Subject", "वर्ग-विषय नियुक्त करा")} arrow>
              <Link onClick={() => handleSubmenuClick("timetableform")} className={selectedSubmenu === "timetableform" ? "active" : ""} to="/timetableform">
                <AssignmentIndIcon />
                <span>
                  {getLabel("Assign Class-Subject", "वर्ग-विषय नियुक्त करा")}
                </span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/weekdayform") && (
            <Tooltip title={getLabel("Assign Period", "तास नियुक्त करा")} arrow>
              <Link onClick={() => handleSubmenuClick("weekdayform")} className={selectedSubmenu === "weekdayform" ? "active" : ""} to="/weekdayform">
                <AssignmentIndIcon />
                <span>{getLabel("Assign Period", "तास नियुक्त करा")}</span>
              </Link>
            </Tooltip>
          )}
          {hasAccess("/timetableform1") && (
            <Tooltip title={getLabel("Class Timetable", "वर्गाचे वेळापत्रक")} arrow>
              <Link onClick={() => handleSubmenuClick("timetableform1")} className={selectedSubmenu === "timetableform1" ? "active" : ""} to="/timetableform1">
                <CalendarMonthIcon />
                <span>{getLabel("Class Timetable", "वर्गाचे वेळापत्रक")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/teachertimetable") && (
            <Tooltip title={getLabel("Teacher's TimeTable", "शिक्षकांचे वेळापत्रक")} arrow>
              <Link onClick={() => handleSubmenuClick("teachertimetable")} className={selectedSubmenu === "teachertimetable" ? "active" : ""} to="/teachertimetable">
                <CalendarMonthIcon />
                <span>{getLabel("Teacher's TimeTable", "शिक्षकांचे वेळापत्रक")}</span>
              </Link>
            </Tooltip>
          )}



          {hasAccess("/principleform") && (
            <Tooltip title={getLabel("All TimeTable", "सर्व वेळापत्रक")} arrow>
              <Link onClick={() => handleSubmenuClick("principleform")} className={selectedSubmenu === "principleform" ? "active" : ""} to="/principleform">
                <DashboardIcon />
                <span>{getLabel("All TimeTable", "सर्व वेळापत्रक")}</span>
              </Link>
            </Tooltip>
          )}
        </div>
      )}

      {hasAccessToDropdown(["/instock", "/outstock", "/balancestock"]) && (
        <Tooltip title={getLabel("Inventory", "इन्व्हेंटरी")} arrow style={{ fontSize: '16px', paddingLeft: '9px' }} className="main-menus" onClick={() => {
          const pages = ["/instock", "/outstock", "/balancestock"];
          if (hasAccessToDropdown(pages)) {
            setShowInventoryDropdown(prevState => !prevState);
            setShowStudentDropdown(false);
            setShowExamDropdown(false);
            setShowPoshanDropdown(false);
            setShowAttendanceDropdown(false);
            setShowICSEExamDropdown(false);
            setShowExam1Dropdown(false);
            setShowTimetableDropdown(false);
            setShowTeacherDropdown(false);
            setShowFeeDropdown(false)
            setShowKirdDropdown(false);
            setShowResultDropdown(false);
          }
        }}>
          <p className="main-menus">
            <img className="icon" src={inv} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />

            <span><b>{getLabel("Inventory", "इन्व्हेंटरी")}</b></span>
          </p>
        </Tooltip>
      )}

      {showInventoryDropdown && (
        <div className="submenu">
          {hasAccess("/instock") && (
            <Tooltip title={getLabel("Stock Inward", "आवक साठा")} arrow>
              <Link
                onClick={() => handleSubmenuClick("instock")}
                className={selectedSubmenu === "instock" ? "active" : ""}
                to="/instock"
              >
                <ArrowDownwardIcon />
                <span>{getLabel("Stock Inward", "आवक साठा")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/outstock") && (
            <Tooltip title={getLabel("Stock Outward", "जावक साठा")} arrow>
              <Link
                onClick={() => handleSubmenuClick("outstock")}
                className={selectedSubmenu === "outstock" ? "active" : ""}
                to="/outstock"
              >
                <ArrowUpwardIcon />
                <span>{getLabel("Stock Outward", "जावक साठा")}</span>
              </Link>
            </Tooltip>
          )}

          {hasAccess("/balancestock") && (
            <Tooltip title={getLabel("Current Stock", "सध्याचा साठा")} arrow>
              <Link
                onClick={() => handleSubmenuClick("balancestock")}
                className={selectedSubmenu === "balancestock" ? "active" : ""}
                to="/balancestock"
              >
                <BalanceIcon />
                <span>{getLabel("Current Stock", "सध्याचा साठा")}</span>
              </Link>
            </Tooltip>
          )}
        </div>
      )}

      {hasAccess("/permissionAccess") && (
        <Tooltip title={getLabel("permission", "परवानगी")} arrow
          className="main-menus"
          style={{ fontSize: "16px", paddingLeft: "9px" }}
        >
          <Link onClick={() => handleSubmenuClick("permissionAccess")} className={selectedSubmenu === "permissionAccess" ? "active" : ""} to="/permissionAccess">
            <img className="icon" src={ps} style={{ height: '28px', margin: '-2px', marginRight: '9px' }} />

            <span>
              <b>{getLabel("permission", "परवानगी")}</b>
            </span>
          </Link>
        </Tooltip>
      )}
      
 {hasAccess("/department") && (
        <Tooltip title={getLabel("Department", "विभाग")} arrow

          className="main-menus"
          style={{ fontSize: "16px", paddingLeft: "9px" }}
        >
          <Link onClick={handleHomeMenuClick} to="/department">
            <img src={hm} className="icon" style={{ height: '30px', margin: '-2px', marginRight: '9px' }} />

            <span>
              <b>{getLabel("Department", "विभाग")}</b>
            </span>
          </Link>
        </Tooltip>
      )}

      <Tooltip title={getLabel("Refer & Earn", "Refer & Earn")} arrow className="main-menus">
        <ReferalCompo />
      </Tooltip>





      <button onClick={toggleSidebar} style={{ backgroundColor: 'transparent', color: '#022750', fontSize: '30px', width: '100%', padding: '5px', marginTop: '-5px', right: 0, textAlign: 'right', height: '20px', marginBottom: '45px' }}>
        {isCollapsed ? ">" : "<"}
      </button>
    </div>
  );
};

export default Sidebar;
